import CloseIcon from '@mui/icons-material/Close';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import {
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';

const parseUploadError = error => {
  // check for file errors
  const fileErrors = error?.body?.upload?.files;
  if (fileErrors && fileErrors.length) {
    // if there are specific file errors, display the first one.
    return `Error uploading file: ${fileErrors[0]}`;
  } else if (error?.body?.error) {
    // if no file errors, check for an "error" property in the response.
    return error.body.error;
  }

  // if there are no specific errors and the request wasn't canceled,
  // show a generic error message
  return 'There was an error uploading.';
};

const FileGroup = ({group, progress, result, onDeleteGroup}) => {
  const fileCount = group.files.length;

  return (
    <Paper
      sx={{p: 1, my: 1, display: 'flex', width: '100%', alignItems: 'center'}}
    >
      <Stack
        sx={{
          gap: 1,
          paddingInlineStart: 1,
        }}
      >
        {fileCount > 1 && <Typography>{group.name}</Typography>}

        <div>
          {group.files.map(file => (
            <Stack key={file.name} sx={{marginLeft: fileCount > 1 ? 2 : 0}}>
              <Stack
                direction="row"
                sx={{
                  gap: 1,
                  alignItems: 'center',
                }}
              >
                <Typography variant={fileCount > 1 ? 'body2' : 'body1'}>
                  {file.name} ({numeral(file.size).format('0b')})
                </Typography>
                {!!progress &&
                  (progress[file.name] === 100 ? (
                    <FileDownloadDoneIcon color="primary" />
                  ) : (
                    <CircularProgress
                      variant="determinate"
                      value={progress[file.name]}
                      size={18}
                    />
                  ))}
              </Stack>
              {!!result?.reason && (
                <Typography color="error" variant="caption" sx={{ml: 1}}>
                  {parseUploadError(result.reason)}
                </Typography>
              )}
            </Stack>
          ))}
        </div>

        {!group.isValid && group.isShapefile && (
          <Typography color="error" variant="body2" sx={{marginLeft: 1}}>
            {`Invalid group: missing primary ".shp" file. File${fileCount > 1 ? 's' : ''} will not be uploaded.`}
          </Typography>
        )}
      </Stack>
      {(!result || result?.status === 'rejected') && !progress && (
        <IconButton onClick={() => onDeleteGroup(group)} sx={{ml: 'auto'}}>
          <CloseIcon />
        </IconButton>
      )}
    </Paper>
  );
};

FileGroup.propTypes = {
  group: PropTypes.object,
  progress: PropTypes.object,
  result: PropTypes.object,
  onDeleteGroup: PropTypes.func,
};

export default FileGroup;
